exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".lights{display:block;padding:15pt;background-color:#fff}", "", {"version":3,"sources":["/home/steven/dev/Sporte/sporte2/src/components/admin/Lights/Lights.vue"],"names":[],"mappings":"AACA,QACE,cAAe,AACf,aAAc,AACd,qBAAwB,CACzB","file":"Lights.vue","sourcesContent":["\n.lights {\n  display: block;\n  padding: 15pt;\n  background-color: white;\n}\n\n\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6bfb41c6","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/admin/Lights/Lights.vue
// module id = 1161
// module chunks = 7